export const validateName = (name?: string) => {
	if (!name) {
		return true;
	}

	return name.length - 1 >= 50;
};
